export default "__VITE_ASSET__7CsT5yHg__"